<div class="page-layout simple left-sidebar inner-sidebar inner-scroll">

    <!-- HEADER -->
    <div class="header accent p-6 flex items-center">
        <!-- BOTÓN DE MENÚ -->
        <!--
        <button
            class="sidebar-toggle mr-2 md:hidden"
            (click)="toggleSidebar('simple-left-sidebar-4')">
            <mat-icon>menu</mat-icon>
        </button>
        -->

        <!-- TÍTULO -->
        <div>
            <span class="text-4xl font-semibold">Administración de Modelos de Instrumento</span>
        </div>
    </div>
    <!-- / HEADER -->

    <!-- CONTENIDO PRINCIPAL -->
    <div class="content flex">

        <!-- SIDEBAR -->
        <!--
        <fuse-sidebar class="sidebar" name="simple-left-sidebar-4" position="left" lockedOpen="gt-md">
        -->
        <div class="sidebar p-6 overflow-y-auto overflow-x-auto" style="max-width: 400px;">
            <entity-list #entityList title="Lista modelos de instrumento" [values]="instrumentModels"
                         [getNameFunction]="showNameAndType.bind(this)" (entitySelected)="selected($event)">
            </entity-list>
        </div>
        <!-- / SIDEBAR -->

        <!-- DIVISOR -->
        <div class="w-px bg-gray-200"></div>

        <!-- CONTENIDO CENTRAL -->
        <div class="center flex flex-col p-6 flex-grow">

            <!-- TÍTULO -->
            <span class="text-3xl font-bold mb-4">Datos del Modelo</span>

            <!-- BOTÓN NUEVO -->
            <div *ngIf="_systemService.canAction('adminClients')" class="pb-4 flex justify-start gap-2">
                <button mat-raised-button color="primary"  class="flex items-center" (click)="newInstrumentModel()" aria-label="NEW">
                    <mat-icon>add</mat-icon>
                    <span class="px-2">Nuevo</span>
                </button>

                <button *ngIf="instrumentModelComp?.instrumentModelForm && instrumentModelComp.action !== 'edit'"
                        mat-raised-button color="warn" (click)="instrumentModelComp.deleteInstrumentModel()"
                        [disabled]="instrumentModelComp.instrumentModelForm.invalid" class="flex items-center"
                        aria-label="DELETE">
                    <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                    <span class="px-2">Borrar</span>
                </button>

                <button *ngIf="instrumentModelComp?.instrumentModelForm && instrumentModelComp.action !== 'edit'"
                        mat-raised-button color="accent" (click)="instrumentModelComp.guardarInstrumentModel()"
                        [disabled]="instrumentModelComp.instrumentModelForm.invalid" class="flex items-center"
                        aria-label="SAVE">
                    <mat-icon svgIcon="heroicons_outline:save"></mat-icon>
                    <span class="px-2">Guardar</span>
                </button>
            </div>
            <!-- FORMULARIO -->
            <div class="content p-6">
                <instrument-model #instrumentModelComp ></instrument-model>
            </div>

        </div>
        <!-- / CONTENIDO CENTRAL -->

    </div>
    <!-- / CONTENIDO PRINCIPAL -->

</div>




